import http from '@/utils/http'

export function getAnswerResults(params){
    return  http('/answerResults',{params})
}

export function getAnswerResultsDetail(id){
    return  http(`/answerResults/${id}`)
}
export function getAnswerToRedis(params){
    return  http('/getAnswerToRedis',{params})
}
export function saveAnswerToRedis(params){
    return  http.post('/saveAnswerToRedis',params)
}
export function delAnswerRedis(params){
    return  http.delete('/delAnswerRedis',{params})
}